import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import "../feautreSelectionScreen.css";
import { Autocomplete, Box, Button, TextField } from "@mui/material";
import {
  convertValuesToConfigNew,
  fetchMultipleUIConfigData,
  fetchUIConfigData,
  getStudioConfigMap,
} from "../../../../services/uiConfigService";
import { openPopup } from "../../../../stateManagement/actions/popupActions";
import { AppOptionType, OptionType } from "../../../manageHomepage/ManageHomePageTypes";
import { getConfigFromClientConfig } from "../../../../services/bannerServices";
import { setCurrentAppType, setCurrentRole } from "../../../../stateManagement/actions/roleActions";
import { Input, Modal } from "@mantine/core";
import RectangleComponent from "../../mandatoryConfigs/uiThemeConfig/widgets/miniScreen";
import { NameValidation, uiAndThemeConfiguration } from "../../../../types";
import { createBlobKey } from "../../../../utils/utils";
import { CameraImageUploader } from "../../mandatoryConfigs/uiThemeConfig/widgets/imageUploader";
import ColorPickerWidget from "../../mandatoryConfigs/uiThemeConfig/widgets/colorPickerWidget";
import { usePopup } from "../../../../components/newPortal/PopUpContext";
import { StudioRoleSelectionAndSavePopupModal } from "../../../../components/newPortal/components/studioRoleSelectionAndSavePopupModal";

const REQUIRED_CONFIG_MAP = {
  "clientconfig" : ["project_configuration","customer_configuration","ui_and_theme_configuration","theme_configuration","app_configuration"]
}

export default function RequiredConfigModal ({savedRole ,savedAppType, roleOptionsProps , appTypeOptions, parentCallback} : {savedRole:OptionType ,savedAppType :AppOptionType , roleOptionsProps:OptionType[] , appTypeOptions:AppOptionType[] , parentCallback:()=>void}) {
    const [loading, setLoading] = useState(true);
    const [roleOptions, setRoleOptions] = useState<OptionType[]>(roleOptionsProps ?? []);
    const [clientHeaderLogo, setClientHeaderLogo] = useState<string | File>();
    const [open, setOpen] = useState<boolean>(false);
    const [clientHeaderLogoHeight, setClientHeaderLogoHeight] =
      useState<number>();
    const initialConfigMapRef = useRef<{ [key: string]: any[] }>({});
    const { showPopup } = usePopup();

    const [UIThemevalues, setUIThemeValues] = useState<any>(
      {}
    );
    const [Projectvalues, setProjectValues] = useState<any>(
      {}
    );
    const [defaultProjectConfig, setDefaultProjectConfig] = useState<any>(
      {}
    );
    const [defaultUIThemeConfig, setDefaultUIThemeConfig] = useState<any>(
      {}
    );
    const [projectConfig, setProjectConfig] = useState<
      any[]
    >([]);
    const [customerConfig, setCustomerConfig] = useState<
      any[]
    >([]);
    const [appConfig, setAppConfig] = useState<
      any[]
    >([]);
    const [themeConfig, setThemeConfig] = useState<
      any[]
    >([]);
    const [UIThemeConfig, setUIThemeConfig] = useState<
      any[]
    >([]);
    const [color, setColor] = useState<string>("");
    
    const isSaveDisabled =
    !savedRole || 
    !clientHeaderLogoHeight || 
    !Projectvalues?.supportNumber?.value || 
    !Projectvalues?.dialCode?.value || 
    !UIThemevalues?.clientHeaderLogo?.value || 
    !UIThemevalues?.themeColor?.value;
    const requiredProjectKeys = ["supportNumber","dialCode"];
    const requiredUIKeys = ["themeColor", "clientHeaderLogoHeight", "clientHeaderLogo"];

    //= modal state handleing ( if should open or close the modal )
    const updateModalState = () => {
      if(loading ){
        if(open==true){
          setOpen(false);
        }
        return ;  
      }
      const hasValidProjectConfig = requiredProjectKeys.every((key) =>
        [...projectConfig, ...customerConfig].some(
          (config) => config.name === key && ((config.type == "string" && config.value.trim() !== "") || (config.type == "number" && !isNaN(config.value)))
        )
      );
     const hasValidUIThemeConfig = requiredUIKeys.every((key) =>
  [...appConfig, ...themeConfig, ...UIThemeConfig].some(
    (config) =>
      config.name === key && ((config.type == "string" && config.value.trim() !== "") || (config.type == "number" && !isNaN(config.value)))
  )
);
      if (initialConfigMapRef.current?.["clientconfig"]?.length > 0) {
        const shouldOpen = !(hasValidProjectConfig && hasValidUIThemeConfig);
        if (shouldOpen) {
          setOpen(true);
        }
      }
    }

    // == state / logic is role and apptype dependend so this changes the local state according to that 
    const updateLocalStateAccordingToRole = () => {
      if(!savedRole || !initialConfigMapRef.current?.["clientconfig"]) return;
      const role = savedRole.id;
      const clientConfig = initialConfigMapRef.current?.["clientconfig"];
      const project_config =  getConfigFromClientConfig(clientConfig,`${role}_project_configuration`) ?? []; 
      const customer_config =  getConfigFromClientConfig(clientConfig,`${role}_customer_configuration`) ?? [];
      const uiTheme_config =  getConfigFromClientConfig(clientConfig,`${role}_ui_and_theme_configuration`) ?? [];
      const theme_config =  getConfigFromClientConfig(clientConfig,`${role}_theme_configuration`)?? [];
      const app_config =  getConfigFromClientConfig(clientConfig,`${role}_app_configuration`) ?? [];
      const color = theme_config.find((config:any)=>config.name === "themeColor")?.value;
      setColor(color);
      setThemeConfig(theme_config);
      setAppConfig(app_config);
      setUIThemeConfig(uiTheme_config);
      setCustomerConfig(customer_config);
      setProjectConfig(project_config);
      setUIThemeConfigValues(uiTheme_config,theme_config,app_config);
      setProjectConfigValues(project_config,customer_config);
      updateModalState();
    }

    // == save config logic 
    const saveConfiguration = async () => {
      
      try {
        const { result: convertedVals, failedValidations, missingFromGlobal } = convertValuesToConfigNew(Projectvalues, projectConfig, defaultProjectConfig);
        if (missingFromGlobal.length > 0) {
          const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
          openPopup("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
          return;
        }
        if (failedValidations.length > 0) {
          const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
          openPopup("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
          return;
        }
        const { result: UIThemeConvertedVals, failedValidations: UIThemeValidations, missingFromGlobal: missingFromGlobalUITheme } = convertValuesToConfigNew(
          UIThemevalues,
          UIThemeConfig,
          defaultUIThemeConfig
        );
        if (missingFromGlobalUITheme.length > 0) {
          const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
          openPopup("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
          return;
        }
        if (UIThemeValidations.length > 0) {
          const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
          openPopup("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
          return;
        }
        const role = savedRole.id;
        const updatedConfigMap = structuredClone(initialConfigMapRef.current);
        const updatedClientConfig = updatedConfigMap?.["clientconfig"];
        updatedClientConfig.forEach((config:any)=>{
          if(config.domainType === `${role}_project_configuration`){
            config.domainValues = convertedVals;
          }
          if(config.domainType === `${role}_ui_and_theme_configuration`){
            config.domainValues = UIThemeConvertedVals;
          }
        })
        showPopup((close) => (
          <StudioRoleSelectionAndSavePopupModal
            inputData={{
              requiredConfigsMap : REQUIRED_CONFIG_MAP,
              initialConfigMap : initialConfigMapRef.current,
              updatedConfigMap : updatedConfigMap,
              appType : savedAppType,
              role : savedRole,
            }}
            onCancel = {close}
            actionPostSuccess = {()=>{
              setOpen(false);
              init();
              parentCallback();
            }}
          />
        ));
      } catch (err) {
        console.log("err===", err);
      }
    };

    // == input handleing logic 
    const updateClientHeaderLogo = async (fileName: string | File) => {
      
      try {
        if (fileName instanceof File) {
          const fileArr = [];
          fileArr.push(fileName as File);
          const blobKeyResp = await createBlobKey(fileArr as File[], "admin");
          setUIThemeValues({
            ...UIThemevalues,
            ["clientHeaderLogo"]: {
              ...UIThemevalues["clientHeaderLogo"],
              value: blobKeyResp?.[0]?.Uri
                ? blobKeyResp?.[0]?.Uri
                : UIThemevalues?.clientHeaderLogo?.value,
              isValueUpdated: true,
              domainType: "app_configuration",
            },
          });
        }
      } catch (e) {
        alert(
          "There seems to be some error in image upload API, please try again after sometime"
        );
      }
  
      setClientHeaderLogo(fileName);
    };

    const removeClientHeaderLogo = () => {
      try {
        
        setUIThemeValues({
          ...UIThemevalues,
          ["clientHeaderLogo"]: {
            ...UIThemevalues["clientHeaderLogo"],
            value: "",
            isValueUpdated: true,
            domainType: "app_configuration",
          },
        });
      } catch (e) {
        alert(
          "There seems to be some error in image upload API, please try again after sometime"
        );
      }
  
      setClientHeaderLogo(undefined);
    };

    const nameValidation = (name: string): NameValidation => {
      if (name.includes(" ")) {
        return {
          status: "failed",
          message: "Image name should not contain spaces",
        };
      }
      return {
        status: "success",
        message: "",
      };
    };

    const setProjectConfigValues = (projectConfig:any[],customerConfig:any[]) => {
      try {
        
        const result:any = {};
        if (customerConfig.length) {
          customerConfig.forEach((attr) => {
            result[attr.name] = attr;
          });
        }
        if (projectConfig.length) {
          projectConfig.forEach((attr) => {
            result[attr.name] = attr;
          });
        }
        
          setProjectValues({ ...result });
      } catch (err) {
        console.error("Error setting project config values:", err);
      }
    };
    const setUIThemeConfigValues = (UIThemeConfig:any[],themeConfig:any[],appConfig:any[]) => {
      try {
        
        const result:any = {}  ;
        if (appConfig.length) {
          appConfig.forEach((attr) => {
            result[attr.name] = attr;
          });
        }
        if (themeConfig.length) {
          themeConfig.forEach((attr) => {
            result[attr.name] = attr;
          });
        }
        if (UIThemeConfig.length) {
          UIThemeConfig.forEach((attr) => {
            result[attr.name] = attr;
          });
        }
        
        setClientHeaderLogoHeight(result.clientHeaderLogoHeight?.value ?? 15);
        setUIThemeValues({ ...result });
  
      } catch (err) {
        console.error("Error setting UI theme config values:", err);
      }
    };

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      
      console.log(e.target.value);
      const keyName = e.target.name;
      if (keyName === "clientHeaderLogoHeight") {
        if (parseInt(e.target.value) > 40) {
          return;
        }
        setClientHeaderLogoHeight(parseInt(e.target.value));
      }
      setUIThemeValues({
        ...UIThemevalues,
        [keyName]: {
          ...UIThemevalues[keyName],
          value: e.target.value,
          isValueUpdated: true,
          domainType: "app_configuration",
        },
      });
    };

    const handleNewColor = (color: string) => {
      
      const keyName = "themeColor";
      setColor(color);
  
      setUIThemeValues((prevValues: any) => {
        const newValues: uiAndThemeConfiguration = {
          ...prevValues,
          [keyName]: {
            ...prevValues[keyName],
            value: color,
            isValueUpdated: true,
            domainType: "theme_configuration",
          },
        };
        return newValues;
      });
    };

    const handleSupportValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      
      if (e.target.name === "supportNumber") {
        if (
          !/^\d*$/.test(e.target.value) ||
          e.target.value.length > 15
  
        ) {
          return;
        }
      }
  
      if (e.target.name === "currencySymbol") {
        setProjectValues({
          ...Projectvalues,
          currency: {
            ...Projectvalues["currency"],
            value: e.target.value,
            isValueUpdated: true,
            domainType: "customer_configuration",
          },
          currencySymbol: {
            ...Projectvalues["currencySymbol"],
            value: e.target.value,
            isValueUpdated: true,
            domainType: "customer_configuration",
          },
        });
      } else {
        const keyName = e.target.name;
        setProjectValues({
          ...Projectvalues,
          [keyName]: {
            ...Projectvalues[keyName],
            value: e.target.value,
            isValueUpdated: true,
            domainType: "customer_configuration",
          },
        });
      }
    };

    const handleKeyCodeBlur = (e: ChangeEvent<HTMLInputElement>) => {
      
      if (parseInt(e.target.value) > 40) {
        openPopup("Error", "Cannot set a value greater than 40px");
        setClientHeaderLogoHeight(15);
        setUIThemeValues({
          ...UIThemevalues,
          ["clientHeaderLogoHeight"]: {
            ...UIThemevalues["clientHeaderLogoHeight"],
            value: 15,
            isValueUpdated: true,
            domainType: "app_configuration",
          },
        });
      }
    };
    // initial states handleing ( only runs onece)
    const init = async ()=>{
      try {
        
        setLoading(true);
        const initialConfigMap = await getStudioConfigMap(REQUIRED_CONFIG_MAP);
        initialConfigMapRef.current = initialConfigMap;
        fetchUIConfigData(setProjectValues, setDefaultProjectConfig, "customer_configuration");
        fetchMultipleUIConfigData(setUIThemeValues, setDefaultUIThemeConfig, ["theme_configuration", "app_configuration"]);
        updateLocalStateAccordingToRole();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    //= use effects 
    useEffect(() => {updateModalState()}, [projectConfig, UIThemeConfig,customerConfig,appConfig,themeConfig]);
    useEffect(() => {updateLocalStateAccordingToRole()},[savedRole,savedAppType])
    useEffect(()=>{
      init();
    },[])
    
    return (<Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={open}
      onClose={() => { }}
      radius="lg"
      size="800px"
      className="confirmationPopUp-modalContainer"
      closeOnClickOutside={false}
    >
      <div className="modal-content" >
        <div className="config-main" style={{padding:"10px", boxShadow:"none"}}>
        <label style={{fontWeight:600,fontSize:"20px",marginTop:"-10px",marginBottom:"10px"}} >
          Please fill the required details to proceed further
        </label>
          <div className="input-fields-temp" style={{ gap: "12px" }}>
          <label style={{fontSize:"14px" ,marginTop:"10px"}} >
              Select App Type
            </label>
            <Autocomplete
             style={{ width: "98%" }}
              options={appTypeOptions}
              value={savedAppType}
              clearIcon={null}
              size="small"
              sx={{
                paddingRight: "0px !important",
                borderRadius: "5px",
              }}
              onChange={(event, value) => {
                if (value && value.id !== savedAppType.id) {
                  setCurrentAppType(value);
                  setRoleOptions(value.designations || []);
                  // only change role if it is not the same as the saved role
                  if(value.designations?.[0]?.id !== savedRole?.id){
                    setCurrentRole(value.designations?.[0]);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  placeholder="Select App Type" 
                  {...params} // Ensure this comes first to include all necessary props
                  sx={{
                    borderRadius: "5px",
                    position: "relative",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#227C9D", // Set the border color here
                      },
                      "&:hover fieldset": {
                        borderColor: "#227C9D", // Border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#227C9D", // Border color when focused
                      },
                    },
                  }}
                  value={savedAppType.label}
                />
              )}
            />
            <label style={{fontSize:"14px" ,marginTop:"10px"}} >
              Select Designation
            </label>
            <Autocomplete
             style={{ width: "98%" }}
              options={roleOptions}
              value={savedRole}
              clearIcon={null}
              size="small"
              sx={{
                paddingRight: "0px !important",
                borderRadius: "5px",
              }}
              onChange={(event, value) => {
                if (value && value.id !== savedRole.id) {
                  setCurrentRole(value);
                }
              }}
              renderInput={(params) => (
                <TextField
                  placeholder="Select Designation" 
                  {...params} // Ensure this comes first to include all necessary props
                  sx={{
                    borderRadius: "5px",
                    position: "relative",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#227C9D", // Set the border color here
                      },
                      "&:hover fieldset": {
                        borderColor: "#227C9D", // Border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#227C9D", // Border color when focused
                      },
                    },
                  }}
                  value={savedRole.label}
                />
              )}
            />
            <div className="theme-field" style={{ margin: 0 }}>
              <label htmlFor="clientLogo" style={{ margin: 0, fontSize:"14px" }}>
                Upload the logo for homepage
              </label>
            </div>
            <div>
              <Box width={"92%"}>
                <CameraImageUploader
                  nameValidation={nameValidation}
                  maxSize={200}
                  image={clientHeaderLogo as string}
                  maximumHeight={512}
                  maximumWidth={512}
                  name="clientHeaderLogo"
                  setImage={updateClientHeaderLogo}
                  currImage={UIThemevalues?.clientHeaderLogo?.value}
                  width="106%"
                  height="90px"
                  removeButton={true}
                  removeFunction={removeClientHeaderLogo}
                  uploadText="Upload image"
                  disable={
                    UIThemevalues?.clientHeaderLogo?.value !== "" ? true : false
                  }
                />
              </Box>
              <div className="theme-field">
                <label htmlFor="dialCode" style={{fontSize:"14px" }}>
                  Adjust the homepage’s header height
                </label>
              </div>
              <div
                className="homepage-logo-container"
                style={{ marginTop: "0px" }}
              >
                <Box display="flex" justifyContent="flex-start">
                  <Box borderRadius="4px" marginRight="35px">
                    <input
                      style={{
                        width: "150%",
                        height: "100%",
                        paddingLeft: "8px",
                        textAlign: "center",
                        border: "1px solid #227C9D",
                        appearance: "none",
                        WebkitAppearance: "none", // For WebKit-based browsers like Safari
                        MozAppearance: "none", // For Firefox
                      }}
                      type="number"
                      name="clientHeaderLogoHeight"
                      max={40}
                      min={15}
                      onBlur={handleKeyCodeBlur}
                      value={clientHeaderLogoHeight}
                      onChange={handleValueChange}
                    />
                  </Box>
  
                  <Box
                    width="90%"
                    height="20%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <RectangleComponent
                      key={UIThemevalues?.clientHeaderLogoHeight?.value}
                      backgroundColor={color}
                      logoHeight={parseInt(UIThemevalues?.clientHeaderLogoHeight?.value ?? "15") || 15}
                      logo={UIThemevalues?.clientHeaderLogo?.value}
                    />
                  </Box>
                </Box>
              </div>
  
              <div className="theme-field" style={{ marginBottom: "-18px",fontSize:"14px" }}>
                <label htmlFor="timeZone">
                  Adjust the theme of the app
                </label>
              </div>
              <ColorPickerWidget
                handleNewColor={handleNewColor}
                currentColor={color}
              />
              <label style={{fontSize:"14px" }}>
              Enter Support Number :
              </label>
              <div style={{ display: 'flex', width: '100%', gap: "15px",marginTop:"10px" }}>
                <div style={{ width: '10%' }}>
                  <Input
                    value={Projectvalues?.dialCode?.value}
                    type="number"
                    name="dialCode"
                    disabled
                  />
                </div>
                <div style={{ width: '90%' }}>
                  <Input
                    value={Projectvalues?.supportNumber?.value}
                    type="number"
                    name="supportNumber"
                    onChange={handleSupportValueChange}
                  />
                </div>
              </div>
  
            </div>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"end",gap:"10px"}}>
          <Button variant="outlined" onClick={saveConfiguration} className="confirm-button" sx={{
            '&:hover': {
              backgroundColor: '#24c6b1',
              color: 'white',
            },
          }} disabled={isSaveDisabled}>
            Save
          </Button>
        </div>
      </div>
    </Modal>)
  }